import bem from 'utils/bem';

export const block = bem('cancellation-loss-aversion-modal');

export const PRO_FEATURES = [
  'Unlimited Unwatermarked Videos',
  'Automated Transcripts',
  'Custom Fonts',
  'Back Catalog Automations',
  'Saved Templates',
  'Unlimited Automations',
  'Unlimited Captions',
  'Support For Long Podcasts',
];

export const BASIC_FEATURES = [
  '10 Unwatermarked Videos Monthly',
  'Custom Fonts',
  'Saved Templates',
  'Unlimited Automations',
  'Unlimited Captions',
  'Add Intro & Outro To Videos',
];
